import { render } from "./incImgSvg.vue?vue&type=template&id=37c0bebc&scoped=true"
import script from "./incImgSvg.vue?vue&type=script&lang=js"
export * from "./incImgSvg.vue?vue&type=script&lang=js"

import "./incImgSvg.vue?vue&type=style&index=0&id=37c0bebc&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c0bebc"]])

export default __exports__